// delightSlice.js
import { createSlice } from '@reduxjs/toolkit';

const delightsSlice = createSlice({
  name: 'delights',
  initialState: {
    delightsData: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    setDelightsData: (state, action) => {
      state.delightsData = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setDelightsData, setLoading, setError } = delightsSlice.actions;

export const selectDelightsData = (state) => state.delights.delightsData;
export const selectIsLoading = (state) => state.delights.isLoading;
export const selectError = (state) => state.delights.error;

export default delightsSlice.reducer;
